import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { signIn, ADMIN_HINT } from '../../lib/store';
export function AdminLogin({
  onSuccess
}: {
  onSuccess: () => void;
}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (signIn(email, password)) {
      onSuccess();
    } else {
      setError('Incorrect email or password.');
    }
  }
  return <div className="retreat-sky flex min-h-screen w-full items-center justify-center px-4" data-id="element-8" data-mp="14l2grarztl1g">
      <motion.form onSubmit={handleSubmit} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-sm rounded-[2rem] bg-white p-8 shadow-card" data-id="element-9" data-mp="zlpk5ybbkzlo">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-lavender-400 to-sky-400 text-white shadow-soft" data-id="element-10" data-mp="qlj90j33gbpo">
          <LockIcon className="h-7 w-7" data-id="element-11" data-mp="1qv1i2jljj8ut" />
        </div>
        <h1 className="text-center font-display text-2xl font-700 text-slate-800" data-id="element-12" data-mp="1qwm9w1gh0doz">
          Admin Sign In
        </h1>
        <p className="mt-1 text-center text-sm text-slate-500" data-id="element-13" data-mp="1c4kgn08woixx">
          Protected area — administrators only.
        </p>

        <div className="mt-6 space-y-4" data-id="element-14" data-mp="24ukn33j2242w">
          <div data-id="element-15" data-mp="24vm03djmt0n9">
            <label htmlFor="admin-email" className="mb-1.5 block font-600 text-slate-700" data-id="element-16" data-mp="24szsjdwqql51">
              Email
            </label>
            <input id="admin-email" type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} className="w-full rounded-2xl border-2 border-slate-200 bg-slate-50 px-4 py-3 focus:border-lavender-400 focus:bg-white focus:outline-none" data-id="element-17" data-mp="1vuo3vhffpxf8" />
          </div>
          <div data-id="element-18" data-mp="oehs2u479v42">
            <label htmlFor="admin-pass" className="mb-1.5 block font-600 text-slate-700" data-id="element-19" data-mp="2r385u4v50k7c">
              Password
            </label>
            <input id="admin-pass" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} className="w-full rounded-2xl border-2 border-slate-200 bg-slate-50 px-4 py-3 focus:border-lavender-400 focus:bg-white focus:outline-none" data-id="element-20" data-mp="2m5g7arzzlzu6" />
          </div>
        </div>

        {error && <p role="alert" className="mt-3 text-sm font-600 text-coral-500" data-id="element-21" data-mp="23g023rdcxj7f">
            {error}
          </p>}

        <button type="submit" className="mt-6 w-full rounded-2xl bg-gradient-to-r from-lavender-500 to-sky-500 px-6 py-3.5 font-display text-lg font-700 text-white shadow-soft transition hover:brightness-105" data-id="element-22" data-mp="1tfr365rzdjoc">
          Sign In
        </button>

        <div className="mt-4 rounded-2xl bg-slate-50 px-4 py-3 text-center text-xs text-slate-500" data-id="element-23" data-mp="3nrnxq7lpz5nm">
          Demo credentials — <span className="font-600" data-id="element-24" data-mp="46yrwsy3gy3o">{ADMIN_HINT.email}</span> /{' '}
          <span className="font-600" data-id="element-25" data-mp="455k3abqw7u3">{ADMIN_HINT.password}</span>
          <br data-id="element-26" data-mp="8xf5qe5tulqk" />
          <span className="text-slate-400" data-id="element-27" data-mp="8yzypzchtwmb">(Swap for Supabase Auth in production.)</span>
        </div>

        <Link to="/" className="mt-4 flex items-center justify-center gap-1.5 text-sm font-600 text-slate-400 transition hover:text-lavender-600" data-id="element-28" data-mp="dvgqr4mtcv4o">
          <ArrowLeftIcon className="h-4 w-4" data-id="element-29" data-mp="3hcqjddizqkqq" />
          Back to voting
        </Link>
      </motion.form>
    </div>;
}